import {savePrints} from "../reducers/printReducer";
import {loader, saveCards} from "../reducers/cardReducer";
import {saveCollection} from "../reducers/collectionReducer";
import {loader as offerLoader, saveOffers} from "../reducers/offersReducer";

export const API_SPEC = {
    SEARCH_CARDS: (params) => {
        return {
            url: `/search?${new URLSearchParams(params).toString()}`,
            method: HttpOperation.GET,
            store: (responseData) => saveCards(responseData),
            loader: (loading) => loader(loading)
        }
    },
    SEARCH_CARD_BY_SET_AND_NO: ({set, no, lang, ...params}) => {
        return {
            url: `/search/${set}/${no}${!!lang ? "?l=" + lang : ""}`,
            method: HttpOperation.GET,
            store: (responseData) => saveCards(responseData),
            loader: (loading) => loader(loading)
        }
    },
    SEARCH_CARD_BY_ID: (id) => {
        return {
            url: `/search/${id}`,
            method: HttpOperation.GET,
            store: (responseData) => saveCards(responseData),
            loader: (loading) => loader(loading)
        }
    },
    SEARCH_PRINTS: (oracleId) => {
        return {
            url: `/search/prints/${oracleId}`,
            method: HttpOperation.GET,
            store: (responseData) => savePrints(responseData)
        }
    },
    COLLECTION: (params) => {
        return {
            url: `/collection?${new URLSearchParams(params).toString()}`,
            method: HttpOperation.GET,
            store: (responseData) => saveCollection(responseData)
        }
    },
    COLLECTION_BY_USER: ({user, ...params}) => {
        return {
            url: `/collection/${user}?${new URLSearchParams(params).toString()}`,
            method: HttpOperation.GET,
            store: (responseData) => saveCollection(responseData)
        }
    },
    COLLECTION_BY_USER_COMPARED: ({user, ...params}) => {
        return {
            url: `/collection/compared/${user}?${new URLSearchParams(params).toString()}`,
            method: HttpOperation.GET,
            store: (responseData) => saveCollection(responseData)
        }
    },
    COLLECTION_ADD: (data) => {
        return {
            url: `/collection`,
            method: HttpOperation.POST,
            data: data,
            store: (responseData) => saveCollection(responseData),
            notification: {
                api: false,
                message: 'Karta została dodana'
            }

        }
    },
    COLLECTION_UPDATE: (data) => {
        return {
            url: `/collection`,
            method: HttpOperation.PUT,
            data: data,
            store: (responseData) => saveCollection(responseData),
            notification: {
                api: false,
                message: 'Karta została zmieniona'
            }
        }
    },
    COLLECTION_DELETE: (id) => {
        return {
            url: `/collection/${id}`,
            method: HttpOperation.DELETE,
            notification: {
                api: false,
                message: 'Card was deleted'
            }
        }
    },
    COLLECTION_DELETE_ALL: () => {
        return {
            url: `/collection`,
            method: HttpOperation.DELETE,
            notification: {
                api: false,
                message: 'All cards was deleted'
            }
        }
    },
    COLLECTION_CLONE: (id) => {
        return {
            url: `/collection/${id}/clone`,
            method: HttpOperation.POST,
            notification: {
                api: false,
                message: 'Card was duplicated'
            },
            store: (responseData) => saveCollection(responseData)
        }
    },
    COLLECTION_ADD_BULK: (data) => {
        return {
            url: `/collection/bulk`,
            method: HttpOperation.POST,
            data: data,
            store: (responseData) => saveCollection(responseData),
            notification: {
                api: false,
                message: 'Karta(y) została dodana'
            }
        }
    },
    OFFERS: ({cardId, offerTypeTab, ...params}) => {
        const sort = offerTypeTab ? 'price,ASC' : 'price,DESC'
        return {
            url: `/offers/${cardId}?${new URLSearchParams({offerTypeTab, sort, ...params}).toString()}`,
            method: HttpOperation.GET,
            store: (responseData) => saveOffers(responseData),
            loader: (loading) => offerLoader(loading)
        }
    },
    OFFERS_ALL: ({offerTypeTab, ...params}) => {
        const sort = offerTypeTab ? 'price,ASC' : 'price,DESC'
        return {
            url: `/offers/?${new URLSearchParams({offerTypeTab, sort, ...params}).toString()}`,
            method: HttpOperation.GET,
            store: (responseData) => saveOffers(responseData),
            loader: (loading) => offerLoader(loading)
        }
    },
}


const HttpOperation = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    UPLOAD: 'POST',
}
